import { inject, Injectable } from '@angular/core';
import { TravelDocumentIndexedDbService } from "../../storage/indexedDb/travel-document-database.service";
import { BaseSynchronizeService } from "@core/services/synchronize/synchronize.service";
import { TravelDocumentRequest, TravelDocumentService } from "@api/api";

@Injectable({
  providedIn: 'root',
})
export class TravelDocumentSynchronizeService extends BaseSynchronizeService<TravelDocumentRequest> {
  database = inject(TravelDocumentIndexedDbService);
  travelDocumentService = inject(TravelDocumentService);
  apiFunction = (data: TravelDocumentRequest) => {
    return this.travelDocumentService.createTravelDocument(data);
  };
}
